module.exports = __webpack_public_path__ + "static/images/intro2_a7f90672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro/intro2.png
// module id = 230
// module chunks = 1